import ControlModule     from 'scripts/poppet/control-module';
import template          from 'templates/controlGeneral.jst.html';
import { Vue } from 'vue/defavue';
import { T } from 'defa-object';

/**
 * defa.views.ControlGeneralHomeView
 * A control module for general home unit functionality.
 * @version 1.3.0
 */
const sliderOptions = [
	{ value: 'ON', title: T.tc('ControlGeneral', 'On'), titleContext: 'ControlGeneral' },
	{ value: 'TIMER', title:T.tc('ControlGeneral', 'Timer'), titleContext: 'ControlGeneral' },
	{ value: 'OFF', title: T.tc('ControlGeneral', 'Off'), titleContext: 'ControlGeneral' } ];

let v ='';


const ControlGeneralHomeView = ControlModule.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template          : template,
	expandedNavState  : '',
	compressedNavState: '',
	
	className: function () {
		// removing this element from the expandable siblings.
		return this._getClassName( 'control-general' ).replace( 'expandable', '' );
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when the html is rendered in the DOM.
	 * @void
	 */
	onDomRefresh: function () {
		let self = this;
		v = new Vue( {
			el: '#general-strip',
			bb() {
				return {
					model: self.model,
				}
			},
			data() {
				return {
					heatingSettingValue: 'OFF',
					smartHeatingSettingValue: false,
					sliderOptions,
					info: 'Deactivate Always ON if you want WarmUp to go from ON to TIMER next time you start your vehicle.' +
						  'If you dont have active pick-up times, WarmUp will automatically be turned off',
					showInfo: false
				}
			},
			methods: {
				save(newValue, attributeName) {
					let data = {};
					data[attributeName]= newValue;
					self.save( data )
				},
			},
			watch: {
				'model.heatingSetting': function (newAttribute){
					this.heatingSettingValue = JSON.parse(JSON.stringify(newAttribute));
				},
				
				'model.smartHeatingSetting': function (newAttribute){
					this.smartHeatingSettingValue = JSON.parse(JSON.stringify(newAttribute));
				}
			},
			created() {
				if(this.model.smartHeatingSetting){
					this.smartHeatingSettingValue = JSON.parse(JSON.stringify(this.model.smartHeatingSetting))
				}
				if(this.model.heatingSetting) {
					this.heatingSettingValue = JSON.parse( JSON.stringify( this.model.heatingSetting ) )
				}
			}
		} );
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------

	/**
	* Save model to backend
	*/
	save: function(attrs) {
		let self = this;
		self.model.set('isValidData', false);
		try {
			this.model.save(attrs, {
				isSaving: true,
				patch: true,
				success: function() {
					console.log('WarmupSetting Model was saved!');
				},
				error: function(model,response, options) {
					console.error( response.responseJSON.message );
					console.error( 'WarmupSetting failed at saving...' );
				}
			});
		} catch ( err ) {
			console.error( err );
			setTimeout( () => this.idle(), 1000 );
		}
	}
	
} );

export default ControlGeneralHomeView;
